import React, {Component} from 'react';
import './StartPaper.scss';
import * as constants from "../../../../const/constants";
import {Button, Col, Container, Row} from 'reactstrap';
import Timer from 'react-compound-timer'
import moment from "moment";
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css'
import * as paperServicess from "../../../../services/papers";
import * as commonFunc from "../../../../utils/commonFunc";
import placeholder from '../../../../assets/img/common/paper.png'
import swal from "sweetalert";
import {lang, language} from "../../../../const/language";
import axios from "axios";
import * as actionModalCreator from "../../../../store/domain/modal/action";
import * as actionSpinnerCreator from "../../../../store/domain/spinner/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";
const Compress = require('compress.js')

class StartPaper extends Component {
    state = {
        paper: undefined,
        mobileView: 0,
        toggleState: 0,
        files: [],
        UrlList: [],
        random:0
    };

    constructor(props) {
        super(props);
        this.updateIframeSrc = this.updateIframeSrc.bind(this);
        this.iframeLoaded = this.iframeLoaded.bind(this);
    }

    componentDidMount() {
        console.log('1')
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;
        this.screeSizeChecking()
        this.getAllSubmittedAnswers()
        // this.loadPdf();
        console.log('2')
    }

    getAllSubmittedAnswers = async () => {
        if (this.state.paper.flowType) {

            console.log('+')
            const data = {
                "classEnrollId": this.state.paper.classEnrollId,
                "quizId": this.state.paper.id,
            }
            await paperServicess.getWrittenPaperAnswers(data)
                .then(res => {
                    if (res.success) {
                        this.setState({
                            UrlList: res.body.writtenAnswersUrlList === null ? [] : res.body.writtenAnswersUrlList
                        })
                    }
                })
                .catch(error => {
                    commonFunc.notifyMessage(error.message, error.status);
                })
        }else {
            const data = {
                "courseEnrollId": this.state.paper.courseEnrollId,
                "quizId": this.state.paper.id,
            }
            await paperServicess.getWrittenCoursePaperAnswers(data)
                .then(res => {
                    if (res.success) {
                        this.setState({
                            UrlList: res.body.writtenAnswersUrlList === null ? [] : res.body.writtenAnswersUrlList
                        })
                    }
                })
                .catch(error => {
                    commonFunc.notifyMessage(error.message, error.status);
                })

        }
    }

    togglePaperAnswer = (e) => {
        this.setState({
            toggleState: e
        })
    }

    async UNSAFE_componentWillMount() {
        console.log('*')
        let state = this.props.location.state;
        if (state) {
            await this.setState({
                paper: state,
            })
        } else {
            this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_VIEW_PAPER_ROUTE}`);
        }
    }

    screeSizeChecking = () => {
        if (window.innerWidth <= 991) {
            this.setState({
                mobileView: 1
            });
        } else {
            this.setState({
                mobileView: 0
            });
        }
    }

    autoEndPaper = async () => {
        this.paperSubmit(3)
    }

    submitPaper = async () => {

        swal({
            title: constants.EXAM_ALERT,
            icon: null,
            closeOnClickOutside: false,
            buttons: {
                cancel: language[lang].NoText,
                dangerMode: {text: language[lang].YesText, value: "action", className: "okay-btn"}
            },
        }).then((value) => {
            switch (value) {
                case "action":
                    this.paperSubmit(2)
                    break;
                default:
                    break;
            }
        });
    }

    paperSubmit = async (state) => {
        if (this.state.paper.flowType) {
            const data = {
                "classEnrollId": this.state.paper.classEnrollId,
                "quizId": this.state.paper.id,
                "writtenAnswers": [],
                "state": state
            }
            this.props.spinnerHandler({isSpin: true, type: 10});
            await paperServicess.submitWrittenPaper(data)
                .then(res => {
                    if (res.success) {
                        this.props.spinnerHandler(false);
                        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_EXAM_ROUTE}`);
                    }
                })
                .catch(error => {
                    this.props.spinnerHandler(false);
                    commonFunc.notifyMessage(error.message, error.status);
                })
        }else{

            const data = {
                "courseEnrollId": this.state.paper.courseEnrollId,
                "quizId": this.state.paper.id,
                "writtenAnswers": [],
                "state": state
            }
            this.props.spinnerHandler({isSpin: true, type: 10});
            await paperServicess.submitWrittenCoursePaper(data)
                .then(res => {
                    if (res.success) {
                        this.props.spinnerHandler(false);
                        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_EXAM_ROUTE}`);
                    }
                })
                .catch(error => {
                    this.props.spinnerHandler(false);
                    commonFunc.notifyMessage(error.message, error.status);
                })

        }
    };

    handleSubmit = async (files) => {
        let answers = [], sorted = [];
        await files.map(async f => {
            if (f.meta.status === 'done'){
                answers.push(f);
                f.remove();
            }
        })

        for(let i=0; answers.length > i; i++) {
            if (answers[i].meta.type.startsWith('image')){
                console.log(answers[i])
                const compress = new Compress();
                await compress.compress([answers[i].file], {
                    size: 2,
                    quality: .25,
                    maxWidth: 1920,
                    maxHeight: 1920,
                    resize: true,
                }).then(async (data) => {
                    sorted.push(data[0].prefix + data[0].data);
                    return true;
                });
            } else {
                console.log(answers[i].file);
                sorted.push(await this.convertBase64(answers[i].file))
            }
        }

        await this.autoSubmitAnswers(sorted);
    }

    convertBase64 = (file) => {
        console.log('F')
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);

            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    autoSubmitAnswers = async (answers) => {

        if (this.state.paper.flowType) {
            const data = {
                "classEnrollId": this.state.paper.classEnrollId,
                "quizId": this.state.paper.id,
                "writtenAnswers": answers,
                "state": 1
            }
            this.props.spinnerHandler({isSpin: true, type: 10});
            await paperServicess.saveWrittenPaperAnswers(data)
                .then(res => {
                    this.props.spinnerHandler(false);
                    if (res.success) {
                        this.getAllSubmittedAnswers()
                    }
                })
                .catch(error => {
                    this.props.spinnerHandler(false);
                    commonFunc.notifyMessage(error.message, error.status);
                })
        }else{
            const data = {
                "courseEnrollId": this.state.paper.courseEnrollId,
                "quizId": this.state.paper.id,
                "writtenAnswers": answers,
                "state": 1
            }
            this.props.spinnerHandler({isSpin: true, type: 10});
            await paperServicess.saveWrittenPaperCourseAnswers(data)
                .then(res => {
                    this.props.spinnerHandler(false);
                    if (res.success) {
                        this.getAllSubmittedAnswers()
                    }
                })
                .catch(error => {
                    this.props.spinnerHandler(false);
                    commonFunc.notifyMessage(error.message, error.status);
                })

        }
    }

    deleteAnswer = (item) => {
        console.log(item)
        swal({
            title: constants.EXAM_ANSWERS_ALERT,
            icon: null,
            closeOnClickOutside: false,
            buttons: {
                cancel: language[lang].NoText,
                dangerMode: {text: language[lang].YesText, value: "action", className: "okay-btn"}
            },
        }).then(async (value) => {
            switch (value) {
                case "action":
                    this.props.spinnerHandler({isSpin: true, type: 10});
                    await paperServicess.deleteWrittenPaperAnswers(item.id)
                        .then(res => {
                            this.props.spinnerHandler(false);
                            if (res.success){
                                this.getAllSubmittedAnswers()
                            }
                        })
                        .catch(error => {
                            this.props.spinnerHandler(false);
                            commonFunc.notifyMessage(error.message, error.status);
                        })
                    break;
                default:
                    break;
            }
        });
    }

    onViewItem = (item) => {
        console.log('O')
        if (item.answersUrl.endsWith('.doc') || item.answersUrl.endsWith('.docx') || item.answersUrl.endsWith('.pdf')){
            window.open(`https://docs.google.com/viewerng/viewer?url=${item.answersUrl}`,'_blank')
        } else {
            window.open(item.answersUrl,'_blank')
        }
    }

    loadPdf = () => {
        this.iframeTimeoutId = setInterval(
            this.updateIframeSrc, 1000 * 10
        );
    }

    iframeLoaded() {
        clearInterval(this.iframeTimeoutId);
    }

    updateIframeSrc() {
        this.refs.iframe.src = this.getIframeLink();
    }

    getIframeLink() {
        return 'https://docs.google.com/gview?embedded=true&url=' + this.state.paper.pdfUrl;
    }

    reloadPaper = async () => {
        await this.setState({random: this.state.random + 1})
        let ran =Math.floor(Math.random() * (1000 - 1 + 1)) + 1;
        await this.setState({randomLoad: ran});
    };

    render() {

        const paper = this.state.paper;
        let newDate = new Date()

        let thisH = moment(newDate).format('hh');
        let thisM = moment(newDate).format('mm');
        let thisS = moment(newDate).format('ss');
        let logH = moment(paper.logTime).format('hh');
        let logM = moment(paper.logTime).format('mm');
        let logS = moment(paper.logTime).format('ss');

        let leftTime = thisH * 60 * 60 * 1000 + thisM * 60 * 1000 + thisS * 1000 - logH * 60 * 60 * 1000 - logM * 60 * 1000 - logS * 1000;

        const availableTime = Number(paper.remaningTime) * 60 * 1000 - leftTime

        return (
            <div>
                <header>

                    <div className={"startpaper-header"}>
                        <div className={"start-paper-titlebar"}>
                            <div>
                                <span className={"startPaper-timer"}>
                                    {
                                        this.state.mobileView === 0 ? <span>Time Remaining: </span> :
                                            <span>Time Left: </span>
                                    }

                                    <Timer
                                        initialTime={availableTime}
                                        direction="backward"
                                        checkpoints={[
                                            {
                                                time: 1 * 1000,
                                                callback: () => this.autoEndPaper(),
                                            },
                                        ]}
                                    >
                                        {() => (
                                            <React.Fragment>
                                                <Timer.Hours/> :
                                                <Timer.Minutes/>:
                                                <Timer.Seconds/>

                                            </React.Fragment>
                                        )}
                                    </Timer>
                                </span>
                            </div>

                            <div className={"complete-btnWrapper"}>
                                {
                                    this.state.mobileView === 0 ?
                                        <span className={"complete-btn"} onClick={this.submitPaper}>
                                            COMPLETE EXAM
                                        </span> :
                                        <span className={"complete-btn"} onClick={this.submitPaper}>
                                            COMPLETE
                                        </span>
                                }

                            </div>
                        </div>
                    </div>
                </header>
                <div>
                    <br/>
                    {
                        this.state.mobileView === 0 ?
                            <div>
                                <main ref="main" style={{display: this.state.toggleState === 0 ? null : "none"}}>
                                    <section className={"startPaper-section"}>
                                        <Container>
                                            <Row>
                                                {/*<Col md={12} lg={12}>*/}
                                                <Button  className={"log-btn "} style={{marginBottom:'10px'}} onClick={this.reloadPaper}>Reload Your Paper </Button>

                                                <p style={{color:'green'}}>( Press this button if you cannot see the paper / ඔබට ප්‍රශ්න පත්‍රය දර්ශනය නොවේනම්, මෙම බොත්තම ඔබන්න. )</p>
                                                {/*</Col>*/}
                                            </Row>
                                            <div>
                                                <Row>
                                                    <Col lg="8" md="8" className={"pdf-wrapper"}>
                                                        {
                                                            this.state.paper !== undefined &&
                                                            <iframe
                                                                ref="iframe"
                                                                // onLoad={this.iframeLoaded}
                                                                // onError={this.updateIframeSrc}
                                                                key={this.state.random}
                                                                className="fullScreen"
                                                                src={'https://docs.google.com/gview?embedded=true&url=' + this.state.paper.pdfUrl}
                                                            />
                                                        }

                                                    </Col>

                                                    <Col md="4" lg="4" sm="6" className={"mt-3 answersheet-wrapper answerSheet"}>
                                                        <h2>Instructions</h2>
                                                        <p className={"description-wrapper"}>{this.state.paper.description}</p>
                                                        <Dropzone
                                                            onSubmit={this.handleSubmit}
                                                            accept="image/*,application/pdf,application/msword,
                                                            application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                        />

                                                        {
                                                            this.state.UrlList.map((file,index) => {
                                                                return(
                                                                    <div key={index} className="answer-holder">
                                                                        <img src={placeholder} alt={"."}
                                                                             className={"answer-img"}
                                                                             onClick={()=>this.onViewItem(file)}
                                                                        />
                                                                             <h6 onClick={()=>this.onViewItem(file)}
                                                                             >View file</h6>
                                                                             <i className="icofont-trash delete-icon"
                                                                                onClick={()=>this.deleteAnswer(file)}/>
                                                                    </div>
                                                                )
                                                            })
                                                        }

                                                    </Col>
                                                </Row>
                                            </div>
                                        </Container>
                                    </section>
                                </main>

                            </div>

                            :

                            <div>
                                <main ref="main">
                                    <section className={"startPaper-section"}>
                                        <Container>
                                            <Row>
                                                <Button  className={"log-btn "} style={{marginBottom:'12px',marginTop:'5px',marginLeft:'12px',marginRight:'12px'}} onClick={this.reloadPaper}>Reload </Button>

                                                <small style={{color:'green',marginTop:'15px'}}>(If you can't see the paper)</small>

                                            </Row>
                                            <div style={{display: this.state.toggleState === 0 ? null : "none"}}>
                                                <Row>
                                                    <Col lg="8" className={"pdf-wrapper"}>
                                                        {
                                                            this.state.paper !== undefined &&
                                                            <iframe
                                                                ref="iframe"
                                                                key={this.state.random}
                                                                className="fullScreen"
                                                                src={'https://docs.google.com/gview?embedded=true&url=' + this.state.paper.pdfUrl}
                                                            />
                                                        }
                                                    </Col>
                                                </Row>
                                            </div>

                                            <div style={{display: this.state.toggleState === 1 ? null : "none"}}>
                                                <Row>
                                                    <Col md="12" lg="12" sm="12"
                                                         className={"mt-3 answersheet-wrapper-mobi answerSheet"}>
                                                        <h2>Instructions</h2>
                                                        <p className={"description-wrapper"}>{this.state.paper.description}</p>
                                                        <Dropzone
                                                            onSubmit={this.handleSubmit}
                                                            accept="image/*,application/pdf,application/msword,
                                                            application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                                        />
                                                        {
                                                            this.state.UrlList.map((file,index) => {
                                                                console.log(file)
                                                                return(
                                                                    <div key={index} className="answer-holder">
                                                                        <img src={placeholder} alt={"."}
                                                                             className={"answer-img"}
                                                                             onClick={()=>this.onViewItem(file)}
                                                                        />
                                                                        <h6 onClick={()=>this.onViewItem(file)}
                                                                        >View file</h6>
                                                                        <i className="icofont-trash delete-icon"
                                                                           onClick={()=>this.deleteAnswer(file)}/>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Container>
                                    </section>
                                </main>

                                <footer>
                                    <div className={"startpaper-footer"}>
                                        <div className={"toggle-btn"} style={{
                                            opacity: this.state.toggleState === 0 ? "1" : "0.5",
                                            borderRight: "1px solid white"
                                        }}>
                                            {/*<i class="icofont-paperclip"></i>*/}
                                            <br/>
                                            <span onClick={(e) => this.togglePaperAnswer(0)}>   Question Paper</span>
                                        </div>
                                        <div className={"toggle-btn"}
                                             style={{opacity: this.state.toggleState === 1 ? "1" : "0.5"}}>
                                            {/*<i class="icofont-tick-boxed"></i>*/}
                                            <br/>
                                            <span onClick={(e) => this.togglePaperAnswer(1)}>Answer Sheet</span></div>
                                    </div>
                                </footer>
                            </div>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
});


const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(StartPaper));
